﻿﻿﻿<div class="container-tab-lists">
    <controllerconfig-menu [datatypes]="controllerconfigdatatypes" [descriptions]="controllerconfigdescriptions" (onRefresh)="refreshAll()"></controllerconfig-menu>
    <div class="inner-tcontainer-tab">
        <div class="tab-body">
            <div class="tab-content">
                <controllerconfig-list [list]="controllerconfigs" [datatypes]="controllerconfigdatatypes" [descriptions]="controllerconfigdescriptions" (onRefresh)="refreshAll()"></controllerconfig-list>
            </div> <!--tab-content-->
        </div> <!--tab-body-->
    </div> <!--inner-tcontainer-tab-->
</div> <!--container-tab-lists-->